function read<T>(file: Blob, start: (reader: FileReader) => void): Promise<T> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as T);
    reader.onerror = () => reject(reader.error ?? new Error('The file could not be read.'));
    reader.onabort = () => reject(new Error('Reading the file was aborted.'));
    start(reader);
  });
}

/** The file as a `data:` URL, e.g. for an image preview or an inline upload. */
export function readFileAsDataUrl(file: Blob): Promise<string> {
  return read<string>(file, (reader) => reader.readAsDataURL(file));
}

/** The file as text; `encoding` defaults to UTF-8 (a leading BOM is dropped). */
export function readFileAsText(file: Blob, encoding = 'utf-8'): Promise<string> {
  return read<string>(file, (reader) => reader.readAsText(file, encoding));
}
